<script setup>
import {reactive} from 'vue'
import {useItemDataStore} from '@/stores/itemData'

const props = defineProps({
    options: {type: Object, required: true}
})

// Define emits explicitly
const emit = defineEmits(['hide-modal'])

const itemDataStore = useItemDataStore()

// Use reactive to wrap the row object to ensure template binding is robust
const row = reactive({...props.options.row})

const saveNotes = () => {
    itemDataStore.update({
        tableName: 'courses_bookings',
        id: row.id,
        data: {notes: row.notes}
    })
}
</script>

<template>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Notes</h4>
                <button type="button" class="btn-close" @click="emit('hide-modal')" aria-label="Close"></button>
            </div>

            <div class="modal-body">
                <textarea v-model="row.notes" placeholder="Type here…" rows="10"
                          style="padding: 15px; width: 100%; font-size: 18px; background: #fff; border: none;"
                          @change="saveNotes"></textarea>
            </div>
        </div>
    </div>
</template>